import { render } from "./ComparativeEquityIndex.vue?vue&type=template&id=1baf2924"
import script from "./ComparativeEquityIndex.vue?vue&type=script&lang=js"
export * from "./ComparativeEquityIndex.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__